/*** convert number or string type to ex. {$1,000} */
export const convertToDollars = (value?: number | string) =>
  Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(Number(Number(value).toFixed(2)) || 0);
